// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/mutation-api-authorize.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn(
  $app_id: uuid!
  $connection_id: uuid
  $connection_properties: jsonb!
  $location_id: uuid!
) {
  apps_external_api_authorize(
    app_id: $app_id
    connection_id: $connection_id
    connection_properties: $connection_properties
    location_id: $location_id
  ) {
    id
    url
  }
}

`